import { render } from "./TextWithPhoto.vue?vue&type=template&id=1083fa43&scoped=true"
import script from "./TextWithPhoto.vue?vue&type=script&lang=js"
export * from "./TextWithPhoto.vue?vue&type=script&lang=js"

import "./TextWithPhoto.vue?vue&type=style&index=0&id=1083fa43&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1083fa43"]])

export default __exports__